export default "__VITE_ASSET__5d9f1a00__"